export default () => ({
  operation: {
    singleOutput: {},
  },
});
